import React from 'react';
import formatBytes from 'common/utils/formatBytes';

// Icons
import iconCsv from 'assets/images/icons_svg/icon-csv.svg';
import iconDoc from 'assets/images/icons_svg/icon-doc.svg';
import iconDocx from 'assets/images/icons_svg/icon-docx.svg';
import iconFile from 'assets/images/icons_svg/icon-file.svg';
import iconMov from 'assets/images/icons_svg/icon-mov.svg';
import iconMp3 from 'assets/images/icons_svg/icon-mp3.svg';
import iconMp4 from 'assets/images/icons_svg/icon-mp4.svg';
import iconPdf from 'assets/images/icons_svg/icon-pdf.svg';
import iconXls from 'assets/images/icons_svg/icon-xls.svg';
import iconOpenInNewSm from 'assets/images/icons_svg/icon_open-in-new-sm.svg';

const fileIcons = {
    csv: iconCsv,
    doc: iconDoc,
    docx: iconDocx,
    mov: iconMov,
    mp3: iconMp3,
    mp4: iconMp4,
    pdf: iconPdf,
    xls: iconXls,
    default: iconFile
};

const getFileIcon = (fileName) => {
    if (!fileName) {
        return iconFile;
    }
    const ext = fileName.split('.').pop()?.toLowerCase();
    return fileIcons[ext] || fileIcons.default;
};

const DisplayDocument = ({ file }) => {
    const openDocument = () => {
        const pdfWindow = window.open('');
        pdfWindow.document.write(
            `<iframe width='100%' height='100%' src="${file.src}"'></iframe>`
        );
    };

    const isPDF =
        file.name?.toLowerCase().endsWith('.pdf') ||
        file.type === 'application/pdf';
    const fileIcon = getFileIcon(file.name);

    return (
        <div className="display-document-container">
            {isPDF ? (
                <div className="display-document-preview">
                    <div className="display-document-thumbnail">
                        <img
                            src={iconPdf}
                            alt="PDF"
                            className="pdf-thumbnail-icon"
                        />
                        <p className="pdf-thumbnail-name">{file.name}</p>
                        <p className="pdf-thumbnail-size">
                            {formatBytes(file.size)}
                        </p>
                    </div>
                    {/* <iframe src={`${file.src}#toolbar=0`} className="display-document-iframe" title={file.name} /> */}
                </div>
            ) : (
                <div className="add-media">
                    <img
                        className="add-media__icon"
                        src={fileIcon}
                        alt=""
                        onClick={openDocument}
                    />
                    <div className="add-media__content">
                        <div className="add-media__title truncate">
                            <span>{file.name}</span>
                        </div>
                        <div className="add-media__subtitle">
                            {formatBytes(file.size)} -{' '}
                            <span onClick={openDocument}>
                                View File <img src={iconOpenInNewSm} alt="" />
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DisplayDocument;
